<template>
<section>
  <cover-image :src="'static/bg-blog.jpg'" :title="'Blog'" :description="''" />
  <div class="container content">
    <div class="empty row" v-if="articles === null">There are no articles yet</div>
    <div class="row" v-else>
      <div class="col-md-7">
        <article-card v-for="article in articles" :key="article" :article="article" :orientation="'left'" :published="checkArticlePublishDate(article.publishDate)" />
      </div>

      <div class="col-md-4 offset-md-1 sidebar">
        <h3 class="row section-title">
          </h3>
      </div>
    </div>
  </div>
</section>
</template>

<script>
import CoverImage from '@/components/ui/CoverImage'
import ArticleCard from '@/components/ui/ArticleCard'
import ArticlesService from '@/services/ArticlesService'

export default {
  name: 'BlogView',
  components: {
    ArticleCard,
    CoverImage
  },
  metaInfo() {
    return {
      title: this.title
    }
  },
  data() {
    return {
      articles: null,
      title: this.$t('navigation.blog')
    }
  },
  props: {
    language: String
  },
  created() {
    this.getBlogPosts()
  },
  methods: {
    getBlogPosts: function() {
      ArticlesService.getByType('blog')
        .then(response => {
          this.articles = response.body
        }, response => {
          console.error(response.body)
        })
    }
  },
  watch: {
    language: function() {
      this.getBlogPosts()
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~styles/_vars.scss';

  .content {
    padding: 1rem;
  }

  .article {
    margin-bottom: 1.5rem;
  }

  .sidebar {}
</style>



// WEBPACK FOOTER //
// BlogView.vue?0ac93fef